// extracted by mini-css-extract-plugin
export default {"root":"_2Vv48","link-overlay":"w4WcT","linkOverlay":"w4WcT"};